import React, { Component, PureComponent, Fragment } from 'react'
import { Map, List, fromJS } from 'immutable'

export let SEND_EMAIL = {
  icon: 'envelope',
  template: e =>
    `Sähköposti lähetetty otsikolla "${e.getIn(['variables', 'subject'])}" henkilöille ${e
      .getIn(['variables', 'to'], List())
      .join(', ')}`,
  color: 'blue',
}

export let INTERVIEW_CREATE_DEFAULT_TASK = {
  icon: 'check',
  template: 'Luotiin oletustehtävä',
  color: '',
}

export let INTERVIEW_CHANGE_NAME = {
  icon: 'edit',
  template: e =>
    `Haastattelun nimi muutettiin "${e.getIn(['variables', 'old_name'])}" -> "${e.getIn([
      'variables',
      'updated_name',
    ])}"`,
  color: 'green',
}

export let INTERVIEW_DELIVERY = {
  icon: 'share',
  template: 'Materiaalit julkaistu dashboardilla',
  color: 'green',
}

export let INTERVIEW_DELIVERY_CANCEL = {
  icon: 'times',
  template: 'Materiaalit poistettu dashboardilta',
  color: 'green',
}

export let INTERVIEW_APPROVAL_ACTION = {
  icon: 'play',
  template: e => {
    let type = e.getIn(['variables', 'action_type'])
    let name = `${e.getIn(['variables', 'target_type']) === 'contact' ? 'Asiakas' : 'Haastateltava'}: ${e.getIn([
      'variables',
      'target_name',
    ])}`

    if (type === 'start') return `Hyväksytysputki aloitettiin henkilölle ${name}`

    if (type === 'restart') return `Hyväksytysputki aloitettiin uudelleen henkilölle ${name}`

    if (type === 'review') return `Korjaukset lähetettiin hyväksyttäväksi henkilölle ${name}`

    if (type === 'reminder') return `Henkilölle ${name} lähetettiin muistutus`

    if (type === 'admin_approve') return `Hyväksytysputki ${name} merkittiin hyväksytyksi hallinnasta`

    return 'Hyväksytys action'
  },
  color: 'purple',
}

export let INTERVIEW_APPROVAL_REMOVE = {
  icon: 'times',
  template: e => {
    let type = e.getIn(['variables', 'action_type'])
    let name = `${e.getIn(['variables', 'target_type']) === 'contact' ? 'Asiakas' : 'Haastateltava'}: ${e.getIn([
      'variables',
      'target_name',
    ])}`

    return `Hyväksytysputki ${name} poistettu`
  },
  color: 'purple',
}

export let INTERVIEW_APPROVAL_ANSWER = {
  icon: 'chat',
  template: e =>
    `Hyväksyttäjä ${e.getIn(['variables', '__inline_user'])} ${
      e.getIn(['variables', 'approved']) ? 'hyväksyi materiaalit' : 'ei hyväksynyt materiaaleja'
    }`,
  color: 'purple',
}

export let INTERVIEW_APPROVAL_AUTOMATE = {
  icon: 'rocket',
  template: 'Hyväksytysputkessa siirryttiin seuraavaan vaiheeseen automaattisesti',
  color: 'purple',
}

export let INTERVIEW_APPROVAL_AUTOMATE_FINAL = {
  icon: 'thumbs up',
  template: 'Kaikki materiaalit hyväksytty',
  color: 'purple',
}

export let INTERVIEW_APPROVAL_CREATE = {
  icon: 'user',
  template: e =>
    `Hyväksytysputki ${e.getIn(['variables', 'target_type']) === 'contact' ? 'Asiakas' : 'Haastateltava'}: ${e.getIn([
      'variables',
      'target_name',
    ])} luotiin`,
  color: 'purple',
}

export let INTERVIEW_APPROVAL_OPENED_FORM = {
  icon: 'eye',
  template: e => `${e.getIn(['variables', '__inline_user'])} avasi lomakkeen`,
  color: 'purple',
}

export let INTERVIEW_APPROVAL_CONSENT = {
  icon: 'check',
  template: e => `${e.getIn(['variables', '__inline_user'])} antoi markkinointiluvan`,
  color: 'purple',
}

export let INTERVIEW_CREATE_FIX_TASK = {
  icon: 'wrench',
  template: e => `Korjauspyyntöä varten luotiin tehtävä käyttäjälle ${e.getIn(['variables', '__inline_user'])}`,
  color: 'purple',
}

export let INTERVIEW_CREATE = {
  icon: 'plus',
  template: 'Haastattelu luotiin',
  color: '',
}

export let INTERVIEW_CREATE_ARTICLE = {
  icon: 'file alternate',
  template: e => `Artikkeli luotiin otsikolla "${e.getIn(['variables', 'title'])}"`,
  color: 'orange',
}

export let INTERVIEW_UPDATE_ARTICLE = {
  icon: 'file alternate',
  template: e => `Artikkeli otsikolla "${e.getIn(['variables', 'title'])}" päivitettiin`,
  color: 'orange',
}

export let INTERVIEW_COPY_ARTICLE = {
  icon: 'file alternate',
  template: e => `Kopioitiin artikkeli "${e.getIn(['variables', 'title'])}" ja arkistoitiin vanha`,
  color: 'orange',
}

export let INTERVIEW_MATERIAL_ARCHIVE = {
  icon: 'folder',
  template: e => `Materiaali nimellä ${e.getIn(['variables', 'filename'])} arkistoitiin`,
  color: 'orange',
}

export let INTERVIEW_MATERIAL_UNARCHIVE = {
  icon: 'undo',
  template: e => `Materiaali nimellä ${e.getIn(['variables', 'filename'])} palautettiin`,
  color: 'orange',
}

export let INTERVIEW_UPLOADED_MATERIALS = {
  icon: 'cloud upload',
  template: e => `Materiaalit ladattiin: ${e.getIn(['variables', 'files'], List()).join(', ')}`,
  color: 'orange',
}

export let INTERVIEW_PERSON_ADD = {
  icon: 'user add',
  template: e => `Haastateltava ${e.getIn(['variables', 'name'])} lisättiin`,
  color: 'turqoise',
}

export let INTERVIEW_PERSON_TRANSFER = {
  icon: 'user',
  template: e => `Haastateltava ${e.getIn(['variables', 'name'])} siirrettiin tähän haastatteluun`,
  color: 'turqoise',
}

export let INTERVIEW_PERSON_UPDATE = {
  icon: 'user',
  template: e => `Haastateltavan ${e.getIn(['variables', 'name'])} tietoja päivitettiin`,
  color: 'turqoise',
}

export let INTERVIEW_PERSON_REMOVE = {
  icon: 'user delete',
  template: e => `Haastateltava ${e.getIn(['variables', 'name'])} poistettiin haastattelusta`,
  color: 'turqoise',
}

function getFilename(url = '') {
  url = url.split('/')
  return url[url.length - 1]
}

export let BURN_CAPTIONS_REQUEST = {
  icon: 'closed captioning',
  template: e => `Tekstityksen poltto lisätty jonoon.`,
  info: e =>
    `Video: ${getFilename(e.getIn(['variables', 'videoUrl']))} Tekstitystiedosto: ${getFilename(
      e.getIn(['variables', 'captionsUrl'])
    )}`,
  color: 'black',
}

export let BURN_CAPTIONS_START = {
  icon: 'closed captioning',
  template: e => `Tekstityksen poltto aloitettu palvelimella.`,
  info: e =>
    `Video: ${getFilename(e.getIn(['variables', 'videoUrl']))} Tekstitystiedosto: ${getFilename(
      e.getIn(['variables', 'captionsUrl'])
    )}`,
  color: 'black',
}

export let BURN_CAPTIONS_ERROR = {
  icon: 'closed captioning',
  template: e => `Virhe tekstityksen poltossa.`,
  info: e =>
    `Video: ${getFilename(e.getIn(['variables', 'videoUrl']))} Tekstitystiedosto: ${getFilename(
      e.getIn(['variables', 'captionsUrl'])
    )}`,
  color: 'black',
}

export let BURN_CAPTIONS_SUCCESS = {
  icon: 'closed captioning',
  template: e => `Tekstityksen poltto valmis.`,
  info: e => (
    <div>
      <a href={e.getIn(['variables', 'url'])}>{e.getIn(['variables', 'filename'])}</a>
    </div>
  ),
  color: 'black',
}

export let NOTE = {
  icon: 'sticky note',
  template: e => (
    <div
      className="event-log-item-message-note"
      dangerouslySetInnerHTML={{ __html: e.getIn(['variables', 'note'], '') }}
    />
  ),
  color: 'yellow',
  note: true,
}

// Contact events

export let DASHBOARD_GET_ORGANIZATION = {
  icon: 'rss',
  template: e => `Ladannut dashboard etusivun`,
  color: 'black',
}

export let DASHBOARD_MAGICLINK_LOGIN = {
  icon: 'sign in',
  template: e => `Kirjautunut dashboardille linkillä`,
  color: 'black',
}

export let COURSE_START = {
  icon: 'play',
  template: e => `Aloittanut kurssin: ${e.getIn(['variables', 'course_name'])}`,
  color: 'purple',
}

export let MARKETING_COURSE_START = {
  icon: 'play',
  template: e => `Aloittanut markkinoinnin kautta kurssin: ${e.getIn(['variables', 'course_name'])}`,
  color: 'orange',
}

export let COURSE_COMPLETE = {
  icon: 'stop',
  template: e => `Katsonut loppuun kurssin: ${e.getIn(['variables', 'course_name'])}`,
  color: 'purple',
}

export let COURSE_GUIDE_DOWNLOAD = {
  icon: 'download',
  template: e => `Ladannut pdf kurssin: ${e.getIn(['variables', 'course_name'])}`,
  color: 'purple',
}

export let MARKETING_REGISTER = {
  icon: 'user',
  template: e => `Luonnut tunnukset markkinoinnin kautta seuraavilla tiedoilla
    ${e.getIn(['variables', 'data', 'custom']).reduce((previous, value, key) => `${previous} ${key}: ${value},`, '')}`,
  color: 'orange',
}
